import { Link } from 'react-router-dom';
import Arrow from './Arrow';
import { trackEvent } from '../lib/analytics';

/**
 * Hero — the CEO concept's framing ("Replace your stack. Run on one runtime."),
 * with the stat strip truth-adjusted: the concept's unverified figures
 * (91.1% vs 53.6%, 38% cheaper, 200+ models, <100ms at 1M records) are
 * replaced with claims defensible against the codebase and docs.
 */
export default function Hero() {
  return (
    <header className="hero" id="top">
      <div className="hero-amb" />
      <div className="wrap">
        <span className="eyebrow ph">RCRT · The Business Intelligence Runtime</span>
        <h1>
          Replace your <span className="ph">stack</span>. Run on one runtime.
        </h1>
        <p className="lede">
          Your business runs on dozens of disconnected SaaS tools. Overlapping, ungoverned,
          billed per seat whether you use them or not. rcrt runs the work those tools do on a
          single governed runtime: agents with persistent memory, sandboxed tools, and
          connectors to the systems you keep — secure, auditable, and priced on what you run.
        </p>
        <div className="hero-cta">
          <Link
            className="btn btn-primary"
            to="/calculator"
            onClick={() => trackEvent('cta_click', { cta: 'see_replace', location: 'hero' })}
          >
            See what you could replace
            <Arrow />
          </Link>
          <Link
            className="btn btn-ghost"
            to="/how-it-works"
            onClick={() => trackEvent('cta_click', { cta: 'how_it_works', location: 'hero' })}
          >
            How it works ↓
          </Link>
        </div>
        <div className="hero-stats">
          <div className="hstat">
            <div className="n">50–200ms</div>
            <div className="l">Context assembled per turn by the LOD memory engine</div>
          </div>
          <div className="hstat">
            <div className="n">300+</div>
            <div className="l">AI models routable through one address. Switch per agent, never locked in</div>
          </div>
          <div className="hstat">
            <div className="n">Minutes</div>
            <div className="l">To build and integrate a new service — connectors are definitions, not deploys</div>
          </div>
          <div className="hstat">
            <div className="n">1 install</div>
            <div className="l">Ships a full agent bundle — agents, tools, knowledge and services, as a unit</div>
          </div>
        </div>
      </div>
    </header>
  );
}
